export default __webpack_public_path__ + "d6a143c7bb947c88d8fe00d8aa2ecde4.png";